import React, { createContext, useContext } from 'react'

const MemoryRouterContext = createContext()

export const useMemoryRouterContext = () => {
  return useContext(MemoryRouterContext)
}

export const MemoryRouterProvider = ({ children, linksAsButtons }) => {
  return <MemoryRouterContext.Provider value={linksAsButtons}>{children}</MemoryRouterContext.Provider>
}
